import { useMemo, useState } from "react";

import NotificationCountContext, {
  NotificationCountType,
} from "./notificationCountContext";

const NotificationCountProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const InitialNotificationCountState = {
    count: 0,
  };

  const [notificationCountState, notificationCountStateSetState] =
    useState<NotificationCountType>(InitialNotificationCountState);

  const stateValue = useMemo(
    () => [{ notificationCountState, notificationCountStateSetState }],
    [notificationCountState, notificationCountStateSetState]
  );

  return (
    <NotificationCountContext.Provider value={stateValue}>
      {children}
    </NotificationCountContext.Provider>
  );
};

export default NotificationCountProvider;
